import script from "./SixthSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./SixthSection.vue?vue&type=script&setup=true&lang=ts"

import "./SixthSection.vue?vue&type=style&index=0&id=56b31587&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56b31587"]])

export default __exports__